export default {
  title: 'Nouvelle marque',
  tabs: {
    general: 'Général',
    branding: 'Image de marque',
    scripts: 'Scripts',
    tracking: 'Suivi',
    domain: 'Domaine',
  },
  fields: {
    name: {
      label: 'Nom',
      placeholder: 'Nom de la marque',
    },
    slug: {
      label: 'Sous-domaine',
      placeholder: 'Sous-domaine de la marque',
      hint: "Lettres minuscules, chiffres et tirets. Avec le domaine de la boutique, il forme l'adresse de la boutique.",
      preview: 'Adresse de la boutique : {{url}}',
      availability: {
        taken: 'Une autre marque utilise déjà ce sous-domaine sur ce domaine de boutique.',
        reserved: 'Ce sous-domaine est réservé. Choisissez-en un autre.',
        invalid_label:
          'Sur ce domaine de boutique, le sous-domaine ne peut contenir que des lettres minuscules, des chiffres et des tirets, doit commencer et se terminer par une lettre ou un chiffre et ne peut pas dépasser 63 caractères.',
        taken_elsewhere:
          'Une marque sur un autre domaine de boutique utilise déjà ce sous-domaine. Choisissez-en un autre.',
        format: 'Utilisez uniquement des lettres, des chiffres, des tirets et des underscores.',
        unavailable: 'Ce sous-domaine n’est pas disponible. Choisissez-en un autre.',
      },
    },
    shop_domain_id: {
      label: 'Domaine de la boutique',
      placeholder: 'Sélectionner un domaine de boutique',
      move_warning: {
        title: 'Cela change l’adresse de la boutique utilisée par les clients',
        description:
          'Après l’enregistrement, la boutique sera à {{url}}. Les QR codes, flyers et liens déjà imprimés ou partagés avec l’ancienne adresse ne fonctionneront plus.',
      },
    },
    lieferando_url: {
      label: 'URL Lieferando',
      placeholder: 'URL du restaurant sur Lieferando',
    },
    primary_color: {
      label: 'Couleur principale',
    },
    logo: {
      label: 'Logo',
    },
    image: {
      label: 'Image',
    },
    companies: {
      label: 'Restaurants',
    },
    noscripts: {
      description: "Injecter le code juste après l'ouverture du body",
    },
    facebook_pixel: {
      label: 'Facebook Pixel',
    },
    facebook_conversion_api_access_token: {
      label: "Token d'accès aux conversions Facebook",
    },
    google_analytics_id: {
      label: 'ID Google Analytics',
    },
    google_ads_conversion_label_id: {
      label: 'Libellé de conversion Google Ads',
    },
    // Named in the modal's error summary when the domain is refused.
    online_shop_domain: {
      label: 'Domaine propre pour la boutique en ligne',
    },
  },
  buttons: {
    save: 'Enregistrer',
    close: 'Fermer',
    sync_from_lieferando: 'Synchroniser depuis Lieferando',
  },
  toasts: {
    changes_saved_successfully: 'Les modifications ont été enregistrées avec succès !',
    failed_to_update_company_slug: 'Échec de la mise à jour du slug pour {{name}}',
    failed_to_sync_lieferando: 'Échec de la synchronisation depuis Lieferando',
    successfully_synced_lieferando: 'Données synchronisées depuis Lieferando avec succès',
    failed_to_load_shop_domains: 'Impossible de charger les domaines de boutique.',
    logo_file_too_large: 'Le logo est trop volumineux. La taille maximale est de {{max}} Mo.',
    logo_dimensions_too_large:
      'Le logo est trop grand. La largeur et la hauteur ne doivent pas dépasser {{max}} pixels.',
  },
};
